import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypePayment } from '../models/typePayment.model';
import { PaginatedList } from '../models/paginatedList.model';
import { RestResponse } from '../models/restResponse.mode';
import { TypePaymentDto } from '../models/dtos/typePayment.dto';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TypePaymentService {
    private readonly baseUrl = `${environment.base_url}/type-payments`;

    constructor(private http: HttpClient) { }


    getAll(): Observable<RestResponse<TypePayment[]>> {
        return this.http.get<RestResponse<TypePayment[]>>(this.baseUrl);
    }

    getActive(): Observable<RestResponse<TypePayment[]>> {
        return this.http.get<RestResponse<TypePayment[]>>(`${this.baseUrl}/active`);
    }
    create(dto: TypePaymentDto): Observable<RestResponse<TypePayment>> {
        return this.http.post<RestResponse<TypePayment>>(`${this.baseUrl}/create`, dto);
    }

    update(id: number, dto: TypePaymentDto): Observable<RestResponse<TypePayment>> {
        return this.http.put<RestResponse<TypePayment>>(`${this.baseUrl}/${id}`, dto);
    }

    findById(id: number): Observable<RestResponse<TypePayment>> {
        return this.http.get<RestResponse<TypePayment>>(`${this.baseUrl}/find/${id}`);
    }

    list(search: string = '', page: number = 1): Observable<RestResponse<PaginatedList<TypePayment[]>>> {
        return this.http.get<RestResponse<PaginatedList<TypePayment[]>>>(`${this.baseUrl}/list`, {
            params: {
                search,
                page: page.toString()
            }
        });
    }

    delete(id: number): Observable<RestResponse<void>> {
        return this.http.delete<RestResponse<void>>(`${this.baseUrl}/${id}`);
    }
} 